import React, { Component, useState } from 'react';
import moment from 'moment';
import {Link} from 'react-router-dom';
import Menu from './Menu.js';

import { useMediaQuery } from 'react-responsive';

import logoWhite from '../img/logo_white_full_lg_2025.png';
import menuOpen from '../img/menu-open.png';
import PhoneIcon from '../img/phone.png';
import arrowDownWhite from '../img/arrow_down_white.png';
import defaultAvatar from '../img/icons-2025/user/user-white.svg';
import defaultAvatar2 from '../img/icons-2025/user/user.svg';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import {available} from '../config.js';

import iconMedidor from '../img/icons-2025/medidor.svg';
import iconGranel from '../img/icons-2025/tanques-tanque-generico.svg';
import iconCilynder from '../img/icons-2025/cilindros-normal.svg';
import ReactDOM from 'react-dom';

import {readNotifications} from '../api.js';
function App(props) {
	const [hideOnScroll, setHideOnScroll] = useState("scrolling-top");
	const isSmall = useMediaQuery({ query: '(max-width: 1100px)' });
	useScrollPosition(({ prevPos, currPos }) => {
	  var scroll = null;
	  if(currPos.y > -115) {
	  	scroll = "scrolling-top"
	  }
	  else if(currPos.y > prevPos.y) {
	  	scroll = "scrolling-up"
	  }
	  else if(currPos.y < prevPos.y) {
	  	scroll = "scrolling-down"
	  }
	  if(scroll !== hideOnScroll) setHideOnScroll(scroll)
	}, [hideOnScroll])
	  return <Frame  {...props} scroll={hideOnScroll} isSmall={isSmall} />;
}
export default App;
class Frame extends Component {
	constructor(props) {
		super(props);
		this.state = {
		  	user_expanded: false,
		  	notifications_expanded: false,
			info_expanded: false,
		  	menu_opened: !props.isSmall
		};
	}

	toggleMenu() {
		this.setState({menu_opened: !this.state.menu_opened});
	}
	
	toggleUserExpanded() {
		if(!this.state.user_expanded) {
			this.setState({notifications_expanded: false, user_expanded: true});
		} else {
			this.setState({user_expanded: false});
		}
	}
	toggleNotificationsExpanded() {
		if(!this.state.notifications_expanded) {
			this.setState({notifications_expanded: true, user_expanded: false});
			readNotifications((error) => {if(error) return console.log("error leyendo notificaciones")});
		} else {
			this.setState({notifications_expanded: false});
		}
	}
	toggleInfoExpanded(){
		if(!this.state.info_expanded) {
			this.setState({info_expanded: true});
		} else {
			this.setState({info_expanded: false});
		}	
	}
	render() {
		var profilePicture = this.props.user.profile_picture?this.props.user.profile_picture:defaultAvatar;
		 
		return (
			
			<div className={this.props.scroll}>
				<Menu 
					opened={this.state.menu_opened} 
					toggleMenu={this.toggleMenu.bind(this)} 
					location={this.props.location} 
					menuOptions={this.props.menuOptions} 
					onClick={() => {if(this.props.isSmall)this.toggleMenu()}} 
					user={this.props.user}
				/>
				<div className={"header-container" + (this.state.menu_opened ? " menu-opened" : "")}>
					<div style={{position: "relative"}}>
					<div style={{position: "absolute", top: 0, left: 0, right: 0}}>
						<div className={"header-gradient" + (this.props.header_class?" "+this.props.header_class:"")}>
							<div className="header-columns">
								<div className="flex-row align-items-center cta-mobile">
									<img alt="" src={menuOpen} className="menu-open" onClick={() => this.toggleMenu()} />
									<img alt="Abastible - Sucursal Virtual" src={logoWhite} className="header-logo" />
									<div className="flex-row align-items-center not-selectable gap-2 float-left mt-5 w-full sm: text-ellipsis sm: text-sm">
										<a href='tel:800209000'>
											<img alt="" src={PhoneIcon} className="guest-header-icon" />
										</a>
										<a href='tel:800209000'>
											<p className="color-white light">Emergencias: <strong>800 20 9000</strong></p>
										</a>
										<div className="pointer" onClick={() => {this.toggleInfoExpanded()}}>
											<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M9.56075 14.25C9.72275 14.25 9.857 14.1957 9.9635 14.087C10.0698 13.9782 10.123 13.8434 10.123 13.6827V9.06725C10.123 8.90658 10.0682 8.77183 9.9585 8.663C9.84883 8.55433 9.713 8.5 9.551 8.5C9.38883 8.5 9.2545 8.55433 9.148 8.663C9.04167 8.77183 8.9885 8.90658 8.9885 9.06725V13.6827C8.9885 13.8434 9.04333 13.9782 9.153 14.087C9.26267 14.1957 9.39858 14.25 9.56075 14.25ZM9.49875 6.9C9.69125 6.9 9.85308 6.83658 9.98425 6.70975C10.1152 6.58292 10.1808 6.42575 10.1808 6.23825C10.1808 6.03675 10.1156 5.86975 9.98525 5.73725C9.85475 5.60475 9.69317 5.5385 9.5005 5.5385C9.30217 5.5385 9.139 5.60525 9.011 5.73875C8.88317 5.87208 8.81925 6.03742 8.81925 6.23475C8.81925 6.42325 8.88433 6.58125 9.0145 6.70875C9.14483 6.83625 9.30625 6.9 9.49875 6.9ZM9.50825 19C8.19242 19 6.95925 18.7507 5.80875 18.252C4.65842 17.7533 3.65217 17.0724 2.79 16.2092C1.92783 15.3461 1.24725 14.3396 0.74825 13.1897C0.249417 12.0401 0 10.8082 0 9.494C0 8.17983 0.249333 6.946 0.748 5.7925C1.24667 4.639 1.92758 3.63467 2.79075 2.7795C3.65392 1.92433 4.66042 1.24725 5.81025 0.74825C6.95992 0.249417 8.19183 0 9.506 0C10.8202 0 12.054 0.249333 13.2075 0.748C14.361 1.24667 15.3653 1.92342 16.2205 2.77825C17.0757 3.63308 17.7528 4.63833 18.2518 5.794C18.7506 6.94967 19 8.18225 19 9.49175C19 10.8076 18.7507 12.0408 18.252 13.1913C17.7533 14.3416 17.0766 15.3463 16.2218 16.2055C15.3669 17.0645 14.3617 17.745 13.206 18.247C12.0503 18.749 10.8177 19 9.50825 19Z" fill="white"/>
											</svg>
										</div>
										{!this.state.info_expanded?null:<ExpandedInfo toggleInfoExpanded={this.toggleInfoExpanded.bind(this)} />}
									</div>
								</div>
								<div className="header-user-bar flex-row align-items-center not-selectable">
									{!available.header_notifications?null:
									<div className="header-circle icon bell-icon" onClick={() => {this.toggleNotificationsExpanded()}}>
										{this.props.notifications&&this.props.notifications.filter((n)=>n.status==="0").length?<div className="header-notification-bell-circle">
											<p className="color-white fw600">{this.props.notifications?this.props.notifications.filter((n)=>n.status==="0").length:"-"}</p>
										</div>:null}
										{!this.state.notifications_expanded?null:
											<ExpandedNotifications toggleNotificationsExpanded={this.toggleNotificationsExpanded.bind(this)} notifications={this.props.notifications}
									            redirectWithData={this.props.redirectWithData}
											 />}
									</div>}
									<div className="user-header" onClick={() => {this.toggleUserExpanded()}}>
										<div className="header-circle header-avatar" style={{backgroundImage: "url(" + profilePicture + ")"}}>
										</div>
										<p className="header-username color-white fw600">
											{this.props.user ? this.props.user.name + " " + this.props.user.last_name : ""}
										</p>
										<img src={arrowDownWhite} className="header-user-arrow" alt="arrow" />
										{!this.state.user_expanded?null:
											<ExpandedUser user={this.props.user} logout={this.props.logout} user_expanded={this.state.user_expanded} />}
									</div>
								</div>
							</div>
							{/*this.props.header ? this.props.header() : null*/}
						</div>
						<div className="header-gradient-image">
						</div>
					</div>
					</div>
					<div className="content">
						<div className="content-header-margin">
							{this.props.children}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export class ExpandedUser extends Component {
	render() {
		var profilePicture = this.props.user.profile_picture?this.props.user.profile_picture:defaultAvatar2;		
		return (
			<div className={"header-user-bar-expanded" + (this.props.user_expanded ? " opened" : "")}>
				<div className="col-30 left">
					<div className="header-circle header-avatar" style={{backgroundImage: "url(" + profilePicture + ")"}}>
					</div>
				</div>
				<div className="left header-userbar-avatar">
					<p className="header-username fw600">{this.props.user.name} {this.props.user.last_name}</p>
					<p className="header-mail">{this.props.user.email}</p>
					<Link to={'/editar-perfil'}><p className="edit-profile button orange transition">Editar Perfil</p></Link>
					<div className="logout transition" onClick={() => {this.props.logout()}}>Cerrar Sesión</div>
				</div>
			</div>
		);
	}
}
export class ExpandedNotifications extends Component {
	
	render() {
		return (
			<div onClick={(e)=> e.stopPropagation()} className={"header-notifications header-user-bar-expanded opened"}>
				<p className="header-notifications-title uppercase fw700 font-12">Notificaciones</p>
				<div className="header-notifications-content">
				{!this.props.notifications?null:this.props.notifications.map((notification, i)=> 
					<Notification key={notification.id} 
	            		redirectWithData={this.props.redirectWithData}
	            		toggleNotificationsExpanded={this.props.toggleNotificationsExpanded}
						notification={notification} />)}
				</div>
			</div>
		);
	}                                                                                                                        
}
export class ExpandedInfo extends Component {
	render() {
		return (
			<div className="header-info-bar opened">
				<span className='title'>¿Tienes una emergencia con tu cilindro <br />o instalación de gas?</span>                
				<ul className='ul'>
					<li>Cierra la llave de paso para detener el <br />suministro.</li>                                 
					<li>Abre puertas y ventanas para ventilar el <br />lugar.</li>
					<li>No uses fósforos, encendedores ni <br />aparatos eléctricos.</li>
					<li>Si hay niños o adultos mayores, llévalos <br />a un espacio ventilado.</li>
					<li>Luego, llámanos a nuestro servicio de <br />emergencias para recibir asistencia <br />técnica inmediata al 
						<a href='tel:800209000' className="color-black">
							800 20 9000
						</a>
					.</li>
				</ul>
			</div>
		);
	}
}
export class Notification extends Component {	
	attachNode(node) {
    	this._form = ReactDOM.findDOMNode(node);
  	}
	notificationClick(notification) {
		var data = null;
		if(notification.data) data = JSON.parse(notification.data);
		if(data.type === "external") this._form.submit();
		else if(data.type === "internal") {
			this.props.redirectWithData(data.data);
			this.props.toggleNotificationsExpanded();
		}
	}
	render() {
		var notification = this.props.notification;
		var icon = null;
		var title = "";
		if(parseInt(notification.business_line_id) === 3) {
			icon = iconGranel;
			title = "Granel Habitacional";
		}
		if(parseInt(notification.business_line_id) === 1) {
			icon = iconMedidor;
			title = "Medidor";
		}
		if(parseInt(notification.business_line_id) === 4) {
			icon = iconCilynder;
			title = "Cilindro";
		}
		if(parseInt(notification.business_line_id) === 6) {
			icon = iconGranel;
			title = "Granel Industrial";
		}
		var data = null;
		if(notification.data) data = JSON.parse(notification.data);
		var formValues = [];
		if(data && data.type === "external" && data.data) {
			for (const prop in data.data) {    				
				formValues.push(<input type="hidden" name={prop} value={data.data[prop]} />);
			}
		}
		return (
			<div className={"header-notification flex flex-row" + (data? " pointer":"")} onClick={()=> data?this.notificationClick(notification):null}>
				<div>
					<img className={"header-notification-icon"} src={icon} />
				</div>
				<div>	
					<div className="flex flex-row justify-between">
						<div className="fw700 font-13">{title}</div>
						<div className="font-8 color-gray capitalize">{moment(notification.created_at).format("D MMM")}</div>
					</div>
					<div className="font-10">{notification.description}</div>
				</div>	
				{data && data.type === "external"?
				<form ref={this.attachNode.bind(this)} target="_blank"
				method="POST" action={data.url}>
				{formValues}
				</form>:null}
			</div>
		);
	}
}
